module.exports = __webpack_public_path__ + "img/1.0378d3b4.jpg";